import { ButtonDropdown, Flex, NavItem, Spacing, Text } from '@billy/design-system'
import React, { ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../hooks'
import { useBankMatchesToolbarFilters } from '../../context/BankMatchesToolbarFiltersContext'
import { BankMatchesSortFilterDropdownValue, getSortFilterId, getSortingItems } from '../../utils/getSortingItems'

export const BankMatchesSorting = (): ReactElement => {
  const { t } = useTranslation()
  const { queryParams, setQueryParams } = useBankMatchesToolbarFilters()
  const { track } = useSegment()

  const items: NavItem<BankMatchesSortFilterDropdownValue>[] = useMemo(() => getSortingItems(t), [t])

  const handleSelect = useCallback(
    (_id: string, value: BankMatchesSortFilterDropdownValue) => {
      const { direction, property } = value
      setQueryParams({ sortProperty: property, sortDirection: direction })

      track('XXX - Reconciliation Entries Sorted (Client)', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        sort_property: property,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        sort_direction: direction,
      })
    },
    [setQueryParams, track],
  )

  return (
    <Flex gap={Spacing.S8} alignItems="center">
      <Text colorVariant="secondary" nowrap>
        {t('bank_integration.toolbar.sort_filter.label')}
      </Text>
      <ButtonDropdown
        dropdownSize="xl"
        items={items}
        onSelect={handleSelect}
        selectedId={getSortFilterId(queryParams.sortProperty, queryParams.sortDirection)}
        variant="outlined"
        placement="bottom-start"
      />
    </Flex>
  )
}
